// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup_form__umMsv {
  margin: 20px 0;
  max-height: 450px;
  overflow-y: auto;
}
.signup_form__umMsv .signup_formGroup__m3SFp {
  margin-bottom: 12px;
  position: relative;
}
.signup_form__umMsv .signup_eyeIcon__UoU1s {
  cursor: pointer;
  background-color: red;
}
.signup_form__umMsv .signup_signUpBtn__aWRlq,
.signup_form__umMsv .signup_signInBtn__qJuKP,
.signup_form__umMsv .signup_skipBtn__ZSJPV {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 12px 0;
}
.signup_form__umMsv .signup_signUpBtn__aWRlq .signup_forgotPassword__s385w,
.signup_form__umMsv .signup_signInBtn__qJuKP .signup_forgotPassword__s385w,
.signup_form__umMsv .signup_skipBtn__ZSJPV .signup_forgotPassword__s385w {
  font: var(--body-font-two);
  color: var(--brand);
  cursor: pointer;
}
.signup_form__umMsv .signup_signUpBtn__aWRlq button,
.signup_form__umMsv .signup_signInBtn__qJuKP button,
.signup_form__umMsv .signup_skipBtn__ZSJPV button {
  min-width: 120px;
  min-height: 42px;
  text-transform: capitalize;
  box-shadow: unset;
}
.signup_form__umMsv .signup_signUpBtn__aWRlq.signup_signInBtn__qJuKP, .signup_form__umMsv .signup_signUpBtn__aWRlq.signup_skipBtn__ZSJPV,
.signup_form__umMsv .signup_signInBtn__qJuKP.signup_signInBtn__qJuKP,
.signup_form__umMsv .signup_signInBtn__qJuKP.signup_skipBtn__ZSJPV,
.signup_form__umMsv .signup_skipBtn__ZSJPV.signup_signInBtn__qJuKP,
.signup_form__umMsv .signup_skipBtn__ZSJPV.signup_skipBtn__ZSJPV {
  justify-content: space-between;
}
.signup_form__umMsv .signup_or__duKsn {
  width: 100%;
  height: 1px;
  background-color: #e5e5e5;
  margin: 20px 0;
  position: relative;
}
.signup_form__umMsv .signup_or__duKsn p {
  font: var(--body-font-three);
  color: #8692a4;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-transform: capitalize;
  background-color: #faf4f2;
  padding: 0px 10px;
  text-align: center;
}
.signup_form__umMsv .signup_socialLoginBtns__wLekE {
  margin-top: 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 15px;
}
.signup_form__umMsv .signup_socialLoginBtns__wLekE button {
  min-height: 36px;
  box-shadow: unset;
  text-transform: capitalize;
  font: var(--body-font-three);
  font-weight: 500;
}
.signup_form__umMsv .signup_socialLoginBtns__wLekE button img,
.signup_form__umMsv .signup_socialLoginBtns__wLekE button svg {
  width: 16px;
  height: 16px;
  object-fit: scale-down;
}

.signup_forgotPwSection__wJzTE .signup_formContainer__0m\\+lg .signup_titleContainer__\\+XC-S {
  margin-bottom: 5px;
}
.signup_forgotPwSection__wJzTE .signup_formContainer__0m\\+lg h4 {
  font-family: var(--font-alex);
}

@media (max-width: 991px) {
  .signup_form__umMsv {
    margin: 15px 0;
  }
  .signup_form__umMsv .signup_formGroup__m3SFp {
    margin-bottom: 10px;
  }
  .signup_form__umMsv .signup_signUpBtn__aWRlq,
  .signup_form__umMsv .signup_signInBtn__qJuKP,
  .signup_form__umMsv .signup_skipBtn__ZSJPV {
    margin: 10px 0;
  }
  .signup_form__umMsv .signup_signUpBtn__aWRlq button,
  .signup_form__umMsv .signup_signInBtn__qJuKP button,
  .signup_form__umMsv .signup_skipBtn__ZSJPV button {
    min-width: 120px;
    min-height: 30px;
  }
  .signup_form__umMsv .signup_or__duKsn {
    margin: 20px 0;
  }
  .signup_form__umMsv .signup_or__duKsn p {
    font-size: 12px;
  }
  .signup_form__umMsv .signup_socialLoginBtns__wLekE {
    margin-top: 20px;
    gap: 10px;
  }
}
@media (max-width: 767px) {
  .signup_form__umMsv .signup_signUpBtn__aWRlq button,
  .signup_form__umMsv .signup_signInBtn__qJuKP button,
  .signup_form__umMsv .signup_skipBtn__ZSJPV button {
    min-height: 38px;
    min-width: unset;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/signup/signup.module.scss"],"names":[],"mappings":"AAAA;EACC,cAAA;EACA,iBAAA;EACA,gBAAA;AACD;AACC;EACC,mBAAA;EACA,kBAAA;AACF;AAEC;EACC,eAAA;EACA,qBAAA;AAAF;AAGC;;;EAGC,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AADF;AAGE;;;EACC,0BAAA;EACA,mBAAA;EACA,eAAA;AACH;AAEE;;;EACC,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;AAEH;AACE;;;;;EAEC,8BAAA;AAIH;AAAC;EACC,WAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;AAEF;AAAE;EACC,4BAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,0BAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;AAEH;AAEC;EACC,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AAAF;AAEE;EACC,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,4BAAA;EACA,gBAAA;AAAH;AAEG;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;AAAJ;;AAQE;EACC,kBAAA;AALH;AAQE;EACC,6BAAA;AANH;;AAWA;EACC;IACC,cAAA;EARA;EAUA;IACC,mBAAA;EARD;EAWA;;;IAGC,cAAA;EATD;EAWC;;;IACC,gBAAA;IACA,gBAAA;EAPF;EAWA;IACC,cAAA;EATD;EAWC;IACC,eAAA;EATF;EAaA;IACC,gBAAA;IACA,SAAA;EAXD;AACF;AAeA;EAMG;;;IACC,gBAAA;IACA,gBAAA;EAhBF;AACF","sourcesContent":[".form {\r\n\tmargin: 20px 0;\r\n\tmax-height: 450px;\r\n\toverflow-y: auto;\r\n\r\n\t.formGroup {\r\n\t\tmargin-bottom: 12px;\r\n\t\tposition: relative;\r\n\t}\r\n\r\n\t.eyeIcon {\r\n\t\tcursor: pointer;\r\n\t\tbackground-color: red;\r\n\t}\r\n\r\n\t.signUpBtn,\r\n\t.signInBtn,\r\n\t.skipBtn {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: flex-end;\r\n\t\talign-items: center;\r\n\t\tmargin: 12px 0;\r\n\r\n\t\t.forgotPassword {\r\n\t\t\tfont: var(--body-font-two);\r\n\t\t\tcolor: var(--brand);\r\n\t\t\tcursor: pointer;\r\n\t\t}\r\n\r\n\t\tbutton {\r\n\t\t\tmin-width: 120px;\r\n\t\t\tmin-height: 42px;\r\n\t\t\ttext-transform: capitalize;\r\n\t\t\tbox-shadow: unset;\r\n\t\t}\r\n\r\n\t\t&.signInBtn,\r\n\t\t&.skipBtn {\r\n\t\t\tjustify-content: space-between;\r\n\t\t}\r\n\t}\r\n\r\n\t.or {\r\n\t\twidth: 100%;\r\n\t\theight: 1px;\r\n\t\tbackground-color: #e5e5e5;\r\n\t\tmargin: 20px 0;\r\n\t\tposition: relative;\r\n\r\n\t\tp {\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tcolor: #8692a4;\r\n\t\t\tposition: absolute;\r\n\t\t\ttop: 50%;\r\n\t\t\tleft: 50%;\r\n\t\t\ttransform: translate(-50%, -50%);\r\n\t\t\ttext-transform: capitalize;\r\n\t\t\tbackground-color: #faf4f2;\r\n\t\t\tpadding: 0px 10px;\r\n\t\t\ttext-align: center;\r\n\t\t}\r\n\t}\r\n\r\n\t.socialLoginBtns {\r\n\t\tmargin-top: 25px;\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\tjustify-content: center;\r\n\t\tgap: 15px;\r\n\r\n\t\tbutton {\r\n\t\t\tmin-height: 36px;\r\n\t\t\tbox-shadow: unset;\r\n\t\t\ttext-transform: capitalize;\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tfont-weight: 500;\r\n\r\n\t\t\timg,\r\n\t\t\tsvg {\r\n\t\t\t\twidth: 16px;\r\n\t\t\t\theight: 16px;\r\n\t\t\t\tobject-fit: scale-down;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.forgotPwSection {\r\n\t.formContainer {\r\n\t\t.titleContainer {\r\n\t\t\tmargin-bottom: 5px;\r\n\t\t}\r\n\r\n\t\th4 {\r\n\t\t\tfont-family: var(--font-alex);\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 991px) {\r\n\t.form {\r\n\t\tmargin: 15px 0;\r\n\r\n\t\t.formGroup {\r\n\t\t\tmargin-bottom: 10px;\r\n\t\t}\r\n\r\n\t\t.signUpBtn,\r\n\t\t.signInBtn,\r\n\t\t.skipBtn {\r\n\t\t\tmargin: 10px 0;\r\n\r\n\t\t\tbutton {\r\n\t\t\t\tmin-width: 120px;\r\n\t\t\t\tmin-height: 30px;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.or {\r\n\t\t\tmargin: 20px 0;\r\n\r\n\t\t\tp {\r\n\t\t\t\tfont-size: 12px;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.socialLoginBtns {\r\n\t\t\tmargin-top: 20px;\r\n\t\t\tgap: 10px;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\t.form {\r\n\r\n\t\t.signUpBtn,\r\n\t\t.signInBtn,\r\n\t\t.skipBtn {\r\n\t\t\tbutton {\r\n\t\t\t\tmin-height: 38px;\r\n\t\t\t\tmin-width: unset;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `signup_form__umMsv`,
	"formGroup": `signup_formGroup__m3SFp`,
	"eyeIcon": `signup_eyeIcon__UoU1s`,
	"signUpBtn": `signup_signUpBtn__aWRlq`,
	"signInBtn": `signup_signInBtn__qJuKP`,
	"skipBtn": `signup_skipBtn__ZSJPV`,
	"forgotPassword": `signup_forgotPassword__s385w`,
	"or": `signup_or__duKsn`,
	"socialLoginBtns": `signup_socialLoginBtns__wLekE`,
	"forgotPwSection": `signup_forgotPwSection__wJzTE`,
	"formContainer": `signup_formContainer__0m+lg`,
	"titleContainer": `signup_titleContainer__+XC-S`
};
export default ___CSS_LOADER_EXPORT___;
